import { NamedEntityControlSet, NamedEntityControlSetResponse } from './types'

export const mapNamedEntityControlSetForRequest = (
  raw: NamedEntityControlSet
): unknown => ({
  conclusion: raw.conclusion,
  language_code: raw.languageCode,
  text: raw.text,
})

export const mapNamedEntityControlSetForResponse = (
  raw: any
): NamedEntityControlSet => ({
  id: raw.data.id,
  conclusion: raw.data.conclusion,
  currentVersion: raw.data.current_version,
  languageCode: raw.data.language_code,
  text: raw.data.text,
  userId: raw.data.user_id,
})

export const mapNamedEntityControlSetForList = (
  raw: any
): NamedEntityControlSetResponse => ({
  list: raw.data_list.map((item: unknown) =>
    mapNamedEntityControlSetForResponse({ data: item })
  ),
  dataCount: raw.data_count,
  pageCount: raw.page_count,
  message: raw.message,
  success: raw.success,
})
